export default __webpack_public_path__ + "static/mobileGroup-4806d488b9384f7cb533f6254ba709ff.png";